import React from 'react'

import Layout from '../components/core/uxdx/layout'
import MetaData from '../components/core/metaData'
import AgendaWhy from '../components/agendaWhy'
import AgendaOverview from '../components/agendaOverview'
import UpcomingConferences from '../components/upcomingConferences'

const Agenda = () => {
  const goals = [
    {
      name: 'Get Inspired',
      borderColor: 'border-cyan-500',
      description: 'See how other companies are tackling the same problems that you face.',
    },
    {
      name: 'Learn',
      borderColor: 'border-pink-500',
      description: 'Discover the challenges that teams overcame in adopting new practices.',
    },
    {
      name: 'Upskill',
      borderColor: 'border-indigo-500',
      description: 'Get hands on experience with new tools and techniques.',
    },
    {
      name: 'Meet Peers',
      borderColor: 'border-orange-500',
      description: 'Grow your network without the awkwardness of networking.',
    },
  ]

  return (
    <Layout>
      <MetaData
        keywords={[
          'uxdx',
          'product',
          'ux',
          'design',
          'dev',
          'agile',
          'digital transformation',
          'conference',
          'success',
        ]}
        title="How the hybrid UXDX Agenda Works"
        description="An agenda designed to enable more interaction and deeper conversations during the event. Relevant Case Study Talks and Targeted Workshops."
      />

      <section className="w-full">
        <div className="bg-networkingHeader">
          <div className="max-w-screen-xl mx-auto py-16 px-4 sm:py-24 sm:px-6 lg:px-8 lg:flex lg:justify-between">
            <div className="max-w-prose">
              <h1 className="text-4xl leading-10 font-bold text-white sm:text-5xl sm:leading-none lg:text-6xl">
                Not your Standard Agenda
              </h1>
              <p className="mt-5 text-xl leading-7 text-gray-400">
                Re-imagining the agenda to deliver a better experience
              </p>
            </div>
          </div>
        </div>
      </section>

      <section className="mx-auto max-w-7xl flex justify-center content-center pt-16">
        <div className="px-4">
          <h2 className="mt-2 text-4xl md:text-5xl text-gray-900 tracking-tight">
            Aligning the Agenda to Your Needs
          </h2>
          <div className="grid sm:grid-cols-2 md:grid-cols-4 gap-8 pt-10">
            {goals.map((element, index) => (
              <div key={'elements' + index} className={`${element.borderColor} border-l-4 px-4`}>
                <div className="flex">
                  <p className="text-5xl ">{index + 1}</p>
                </div>
                <p className="text-2xl text-gray-700 pt-4">{element.name}</p>
                <p className="text-gray-500 pt-2 text-sm">{element.description}</p>
              </div>
            ))}
          </div>
          <div className="py-16">
            <AgendaOverview />
          </div>
        </div>
      </section>

      {/* <section className="bg-gray-100">
        <div className="max-w-screen-xl pb-8 m-auto px-4 md:px-8 pt-16">
          <h2 className="mt-2 text-4xl md:text-5xl text-gray-900 tracking-tight">
            Making the Most of your Time
          </h2>
          <AgendaWhy />
        </div>
      </section> */}

      <section className="">
        <div className="py-20 max-w-screen-xl mx-auto ">
          {/* <h2 className='text-5xl text-white'>Upcoming Conferences</h2> */}
          <p className="text-lg text-gray-500"></p>
          <UpcomingConferences />
        </div>
      </section>
    </Layout>
  )
}

export default Agenda
